import { CaretLeft } from "@phosphor-icons/react";
import { useNavigate, useParams } from "react-router-dom";
import { StarRating } from "./OrderItem";
import useOrderItemDetails from "../../hooks/useOrderItemDetails";
import { HashLoader } from "react-spinners";
import { formatAsMoney } from "../../helpers/numbers";

const LeaveReview = () => {
  const { itemId } = useParams();
  const navigate = useNavigate();

  const { orderItem, isLoading } = useOrderItemDetails(itemId!);

  if (isLoading) {
    return (
      <div className="fixed top-0 z-50 left-0 h-screen w-screen flex items-center justify-center bg-black/20 backdrop-blur-sm">
        <HashLoader />
      </div>
    );
  }

  const item = orderItem?.data;
  if (!item) {
    return (
      <div className="p-5 aspect-video flex items-center justify-center">
        Order item not found
      </div>
    );
  }

  return (
    <div className="flex flex-col items-start gap-5 px-5 pb-20">
      {/* Header */}
      <div className="flex items-center gap-2 p-4 bg-white">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="p-2 py-3 text-center text-deepBlue border px-6 rounded-xl font-medium flex gap-2 items-center border-gray-300"
        >
          <CaretLeft weight="bold" />
          <span>Back</span>
        </button>
        <h1 className="text-lg font-medium ml-4">Leave a review</h1>
      </div>

      <div className="flex flex-col gap-5 w-full md:px-5">
        <div className="">
          <div className="font-medium text-xl">
            Rate the product that you just purchased
          </div>
          <div>
            Share your honest experience with us. Your feedback helps others
            make informed choices and helps us improve our services.
          </div>
        </div>

        <div className="flex-1">
          {/* Product row */}
          <div className="flex items-center gap-4 bg-white p-4 rounded-lg border">
            <img
              src={item.product?.images?.[0]?.path}
              alt={item.product?.name || "Product Image"}
              className="w-16 h-16 rounded-md object-cover bg-gray-200"
            />
            <div className="flex-1">
              <div className="font-medium truncate">
                {item.product?.name || "Could not fetch product name"}
              </div>
              <div className="text-sm opacity-70">
                Qty: {item?.quantity || "Could not fetch quantity"}
              </div>
            </div>
            <div className="font-medium text-lg">
              ₦ {formatAsMoney(parseFloat(item?.subtotal || "0"))}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <StarRating size={30} />
          <div>
            <span className="text-sm">
              Your rating helps other customers make better decisions
            </span>
          </div>
        </div>

        <textarea
          className="w-full border border-gray-300 rounded-lg p-3"
          rows={5}
          placeholder="Write your review here..."
        ></textarea>

        <button className="p-2 self-end py-3 text-center bg-deepBlue text-white px-10 ring-2 ring-deepBlue/50 rounded-xl font-medium">
          Submit Review
        </button>
      </div>
    </div>
  );
};

export default LeaveReview;
